import { HStack, Text, Tooltip } from '@chakra-ui/react';
import { SFLockIcon } from '@assets/icons';

export default function PrivateLabel({ dark = false }) {
  return (
    <Tooltip label='Private meetings are only visible to invitees of those meetings. Other lens followers will not see data from those meetings.'>
      <HStack
        width='fit-content'
        padding='3px 6px'
        justifyContent='center'
        gap={1}
        borderRadius='lg'
        background={dark ? 'brandPrimary.primary' : 'surface.surface'}
        cursor='help'
      >
        <SFLockIcon
          boxSize={4}
          color={dark ? 'brandPrimary.onPrimary' : 'brandPrimary.primary'}
        />
        <Text
          textTransform='uppercase'
          variant='label-caps-600-md'
          color={dark ? 'brandPrimary.onPrimary' : 'brandPrimary.primary'}
        >
          Private
        </Text>
      </HStack>
    </Tooltip>
  );
}
